import React from "react";
import ReactDOM from "react-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { firestore } from "../../db/config";

class BitAddressForm extends React.Component {
  state = {
    value: this.props.bitCoinAddress,
    copied: false,
  };

  render() {
    return (
      <div>
        <div class="change_field">
          <label>Make payment to the below Bitcoin wallet</label>
          <input
            type="text"
            value={this.state.value}
            onChange={({ target: { value } }) =>
              this.setState({ value, copied: false })
            }
            disabled
          />
        </div>
        <CopyToClipboard
          text={this.state.value}
          onCopy={() => this.setState({ copied: true })}
        >
          <span></span>
        </CopyToClipboard>

        <CopyToClipboard
          text={this.state.value}
          onCopy={() => this.setState({ copied: true })}
        >
          <a className="handle__updates__button">Copy</a>
        </CopyToClipboard>

        {this.state.copied ? (
          <span style={{ color: "red" }}>Copied.</span>
        ) : null}
      </div>
    );
  }
}
export default BitAddressForm;
